






































import Vue from 'vue'
import { BatchDto } from '@/Application/Batch'
import InfoTooltip from '@/UI/Shared/InfoTooltip.vue'

export default Vue.extend({
  name: 'BatchTableRow',
  components: {
    InfoTooltip
  },
  props: {
    batch: {
      type: Object as () => BatchDto,
      required: true
    },
    checks: {
      type: Boolean,
      default: false,
      required: false
    },
    selectedChecks: {
      type: Array as () => string[],
      required: false
    },
    showFianza: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expanded: false,
      checked: false
    }
  },
  mounted () {
    if (this.selectedChecks !== undefined) {
      this.selectedChecks.forEach(item => {
        if (item === this.batch.batchId) {
          this.checked = true
        }
      })
    }
  },
  watch: {
    selectedChecks (): void {
      if (this.selectedChecks !== undefined) {
        this.selectedChecks.forEach(item => {
          if (item === this.batch.batchId) {
            this.checked = true
          }
        })
      }
    }
  },
  methods: {
    normalizeQuantity (quantity: number): string {
      return quantity.toLocaleString('es-ES')
    },
    onButtonClicked (): void {
      this.expanded = !this.expanded
      this.$emit('batchrow-expand-toggled', this.expanded)
    },
    yesNoNullContent (content: boolean | null): string {
      if (content === null) {
        return '-'
      }
      const translatedContent = content === true
        ? this.$t('shared.si')
        : this.$t('shared.non')
      return translatedContent.toString()
    },
    onCheck (checked: boolean): void {
      this.$emit('batchSelecteds', checked)
    }
  }
})
